import axios, { AxiosResponse } from "axios";
import axiosInstance from "../api/axios";

export const getUserById = async (userId: number) => {
  try {
    const response: AxiosResponse<any> = await axiosInstance.get(
      `/user/${userId}`
    );
    return response.data;
    // Handle success (e.g., navigate to another page)
  } catch (error: any) {
    // Handle failure (e.g., show an error message)
    return null;
  }
};
